export default "__VITE_ASSET__66hbJll5__"